module.exports = __webpack_public_path__ + "img/icon-card-fail.c3a41e60.svg";